// Baminger Fabric Swatches v4 — Swatch textures for selection, Renders for product image
(function() {
  if (window.__bamSwatchesLoaded) return;
  window.__bamSwatchesLoaded = true;

  document.addEventListener('DOMContentLoaded', function() {
    var path = window.location.pathname;
    if (!path.startsWith('/products/') || !path.includes('sitzbez')) return;

    fetch(path + '.json').then(function(r) { return r.json(); }).then(function(data) {
      var product = data.product;
      if (!product || product.product_type !== 'Sitzbez\u00fcge') return;

      var assetBase = '';
      var ea = document.querySelector('link[href*="/assets/"]');
      if (ea) assetBase = ea.href.split('/assets/')[0] + '/assets/';

      // Swatch images (fabric close-up textures) — for the small preview tiles
      var S = {
        'Baumwolle Wei\u00df':'swatch-c100b.jpg','Baumwolle Hellgrau':'swatch-c100gc.jpg',
        'Baumwolle Dunkelgrau':'swatch-c100gs.jpg','Baumwolle Schwarz':'swatch-c100n.jpg',
        'GOMMATO 06':'swatch-gom06.jpg','GOMMATO 07':'swatch-gom07.jpg',
        'MILANO 252':'swatch-mil252.jpg','MILANO 254':'swatch-mil254.jpg','MILANO 255':'swatch-mil255.jpg',
        'MILANO 256':'swatch-mil256.jpg','MILANO 260':'swatch-mil260.jpg','MILANO 261':'swatch-mil261.jpg',
        'MILANO 232':'swatch-mil232.jpg','MILANO 266':'swatch-mil266.jpg','BARCELLONA 02':'swatch-bar02.jpg','BARCELLONA 03':'swatch-bar03.jpg',
        'ROMA 145':'swatch-rom145.jpg','ROMA 146':'swatch-rom146.jpg','ROMA 153':'swatch-rom153.jpg',
        'ROMA 156':'swatch-rom156.jpg','ROMA 157':'swatch-rom157.jpg',
        'TRENTO 60':'swatch-tn60.jpg','TRENTO 62':'swatch-tn62.jpg','TRENTO 64':'swatch-tn64.jpg',
        'TRENTO 71':'swatch-tn71.jpg','TRENTO 72':'swatch-tn72.jpg','TRENTO 78':'swatch-tn78.jpg',
        'TRENTO 80':'swatch-tn80.jpg','TRENTO 81':'swatch-tn81.jpg','TRENTO 82':'swatch-tn82.jpg',
        'ROMA 83':'swatch-tn83.jpg','GALASSIA 02':'swatch-galassia02.jpg','GALASSIA 07':'swatch-galassia07.jpg',
        'LISA 01':'swatch-lisa01.jpg','DAILY EURO 6':'swatch-daily-e6.jpg','EUROCARGO E6':'swatch-eurocargo-e6.jpg',
        'Kunstleder Schwarz':'swatch-kl-schwarz.jpg','Kunstleder Grau':'swatch-kl-grau.jpg',
        'KL2.0 Schwarz':'swatch-kl-schwarz.jpg','KL2.0 Grau':'swatch-kl-grau.jpg'
      };

      // Render images (seat render with fabric) — for the main product image
      // Maps option2 value to the render filename prefix used in product media
      var R = {
        'Baumwolle Wei\u00df':'render-c100b','Baumwolle Hellgrau':'render-c100gc',
        'Baumwolle Dunkelgrau':'render-c100gs','Baumwolle Schwarz':'render-c100n',
        'GOMMATO 06':'render-gom06','GOMMATO 07':'render-gom07',
        'MILANO 252':'render-mil252','MILANO 254':'render-mil254','MILANO 255':'render-mil255',
        'MILANO 256':'render-mil256','MILANO 260':'render-mil260','MILANO 261':'render-mil261',
        'MILANO 232':'render-mil232','MILANO 266':'render-mil266',
        'BARCELLONA 02':'render-bar02','BARCELLONA 03':'render-bar03',
        'ROMA 145':'render-rom145','ROMA 146':'render-rom146','ROMA 153':'render-rom153',
        'ROMA 156':'render-rom156','ROMA 157':'render-rom157',
        'TRENTO 60':'render-tn60','TRENTO 62':'render-tn62','TRENTO 64':'render-tn64',
        'TRENTO 71':'render-tn71','TRENTO 72':'render-tn72','TRENTO 78':'render-tn78',
        'TRENTO 80':'render-tn80','TRENTO 81':'render-tn81','TRENTO 82':'render-tn82',
        'ROMA 83':'render-tn83','GALASSIA 02':'render-galassia02','GALASSIA 07':'render-galassia07',
        'LISA 01':'render-lisa01','DAILY EURO 6':'render-daily-e6','EUROCARGO E6':'render-eurocargo-e6',
        'Kunstleder Schwarz':'render-kl-schwarz','Kunstleder Grau':'render-kl-grau',
        'KL2.0 Schwarz':'render-kl-schwarz','KL2.0 Grau':'render-kl-grau'
      };

      var G = {};
      product.variants.forEach(function(v) { var m = v.option1 || '?'; if (!G[m]) G[m] = []; G[m].push(v); });
      var cur = Object.keys(G)[0];

      // Remove any old widget
      var old = document.getElementById('bam-sw');
      if (old) old.remove();

      var wrap = document.createElement('div');
      wrap.id = 'bam-sw';
      wrap.innerHTML =
        '<div class="bam-sw-step"><span class="bam-sw-step-num">1</span> Material w\u00e4hlen</div>' +
        '<div class="bam-sw-tabs" id="bam-tabs"></div>' +
        '<div class="bam-sw-step"><span class="bam-sw-step-num">2</span> Farbe / Muster w\u00e4hlen</div>' +
        '<div class="bam-sw-grid" id="bam-grid"></div>' +
        '<div class="bam-sw-selected" id="bam-sw-info">Bitte Material und Farbe w\u00e4hlen</div>';

      var anchor = document.querySelector('.price');
      if (anchor) {
        anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
        var ic = document.querySelector('.product__info-container');
        if (ic) ic.classList.add('bam-swatches-active');
      }

      function renderTabs() {
        var h = '';
        Object.keys(G).forEach(function(m) {
          h += '<button class="bam-sw-tab' + (m === cur ? ' on' : '') + '" data-mat="' + m + '">' + m + '</button>';
        });
        var el = document.getElementById('bam-tabs');
        el.innerHTML = h;
        el.querySelectorAll('.bam-sw-tab').forEach(function(btn) {
          btn.addEventListener('click', function() { cur = this.getAttribute('data-mat'); renderTabs(); renderGrid(); });
        });
      }

      function renderGrid() {
        var h = '';
        (G[cur] || []).forEach(function(v) {
          var o = v.option2 || v.option1;
          var sf = S[o]; // swatch (fabric texture)
          var bg = !sf ? (o.indexOf('chwarz') > -1 ? '#222' : o.indexOf('rau') > -1 ? '#999' : o.indexOf('ei\u00df') > -1 ? '#f5f5f5' : '#ddd') : '';
          h += '<div class="bam-sw-item" data-vid="' + v.id + '"' + (bg ? ' style="background:' + bg + '"' : '') + '>';
          if (sf) h += '<img src="' + assetBase + sf + '" alt="' + o + '" loading="lazy">';
          h += '<div class="bam-sw-tip">' + o + '</div>';
          h += '<div class="bam-sw-name">' + o + '</div>';
          h += '</div>';
        });
        var el = document.getElementById('bam-grid');
        el.innerHTML = h;
        el.querySelectorAll('.bam-sw-item').forEach(function(item) {
          item.addEventListener('click', function() { selectVariant(parseInt(this.getAttribute('data-vid'))); });
        });
      }

      function switchProductImage(option2) {
        var renderPrefix = R[option2];
        if (!renderPrefix) return;

        // Find the media-gallery element
        var gallery = document.querySelector('media-gallery');
        if (!gallery) return;

        // Find the li whose img src contains the render prefix
        var mediaItems = gallery.querySelectorAll('.product__media-list > li[data-media-id]');
        for (var i = 0; i < mediaItems.length; i++) {
          var img = mediaItems[i].querySelector('img');
          if (!img) continue;
          var src = img.getAttribute('src') || '';
          // Match by render prefix in the filename (handles CDN suffixes like _07021037-...)
          if (src.indexOf('/' + renderPrefix + '.') > -1 || src.indexOf('/' + renderPrefix + '_') > -1) {
            var mediaId = mediaItems[i].getAttribute('data-media-id');
            if (mediaId && typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(mediaId, true);
            }
            return;
          }
        }
      }

      function selectVariant(vid) {
        document.querySelectorAll('.bam-sw-item').forEach(function(e) { e.classList.remove('on'); });
        var el = document.querySelector('[data-vid="' + vid + '"]');
        if (el) el.classList.add('on');
        var v = product.variants.find(function(x) { return x.id === vid; });
        if (!v) return;
        var info = document.getElementById('bam-sw-info');
        var p = parseFloat(v.price).toFixed(2).replace('.', ',');
        info.innerHTML = 'Ausgew\u00e4hlt: <b>' + v.option1 + ' \u2014 ' + (v.option2 || '') + '</b><div class="bam-sw-price">' + p + ' \u20ac pro Sitz</div>';
        var url = new URL(window.location);
        url.searchParams.set('variant', vid);
        window.history.replaceState({}, '', url);
        // Switch the main product image to the render for this fabric
        switchProductImage(v.option2 || v.option1);
        // Also trigger native variant change for cart/pricing
        var selects = document.querySelectorAll('.product-form__input select');
        selects.forEach(function(s, i) {
          var val = i === 0 ? v.option1 : v.option2;
          if (val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }

      renderTabs();
      renderGrid();

      // Preload all swatch images for instant tab switching
      Object.values(S).forEach(function(file) {
        var img = new Image();
        img.src = assetBase + file;
      });
    });
  });
})();
